export const S3_CONFIG = 'S3_CONFIG';

export interface S3Config {
  accessKeyId: string;
  secretAccessKey: string;
  region: string;
  bucket: string;
  basePath: string;
  cacheControl: string;
}

export type AllS3Config = {
  [key in AllowedS3Configs]: S3Config;
}

export enum AllowedS3Configs {
  base = 'base',
  documents = 'documents',
  giftCards = 'giftCards',
  employeeCards = 'employeeCards',
  brandMemberCards = 'brandMemberCards',
}
